/**
 * @generated SignedSource<<a85c54bb0de026146b0b41977149444f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodCreditCardValue_charge$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
  } | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentType": "PaymentMethodCreditCardValue_charge";
};
export type PaymentMethodCreditCardValue_charge$key = {
  readonly " $data"?: PaymentMethodCreditCardValue_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodCreditCardValue_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodCreditCardValue_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "8048ee44e4efb487eb392c7099970157";

export default node;
